import { withChartLayout } from 'components/common';
import PediatricGlasgowComaScale from 'components/features/chart/special-charts/pediatric-glasgow-coma-scale/PediatricGlasgowComaScale';

const PediatricGlasgowComaScalePage = withChartLayout('Pediatric Glasgow Coma Scale')(PediatricGlasgowComaScale);
export default PediatricGlasgowComaScalePage;
